export default "__VITE_ASSET__BBjr3kvE__"